import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { apiMessageQueries } from '@/services/apiMessage/apiMessage.queries';

export const useApiMessageDetail = (apiMessageId: string) => {
  const { data, isLoading } = useQuery({
    ...apiMessageQueries.detail(apiMessageId),
  });

  return { apiMessageDetail: data?.data, isLoading };
};
